import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaYoutube, FaPhone, FaEnvelope, FaMapMarkerAlt, FaArrowUp } from "react-icons/fa";
import AnimateOnScroll from "../AnimateOnScroll";
// Assets

export default function Footer() {
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Wrapper>
      <FooterContent>
        <div className="container">
          <FooterMain>
            <FooterSection>
              <AnimateOnScroll animation="fadeUp" delay={0} duration={800}>
                <FooterBrand>
                  <Link className="flexCenter animate pointer" to="home" smooth={true} offset={-80}>
                    <LogoImage src="/logo.png" alt="AFRIQ Logo" />
                    <h1 className="font20 extraBold whiteColor" style={{ marginLeft: "15px" }}>
                      AFRIQ
                    </h1>
                  </Link>
                  <BrandDescription className="font14">
                    Academic Foundation for Rising Intellectuals in Africa - Helping students study the right way, 
                    understand key concepts, and prepare effectively for competitive entrance exams through structured 
                    concours preparation, expert teaching, academic orientation, and career mentorship.
                  </BrandDescription>
                  <SocialLinks>
                    <SocialLink href="#" target="_blank" aria-label="Facebook">
                      <FaFacebook />
                    </SocialLink>
                    <SocialLink href="#" target="_blank" aria-label="Twitter">
                      <FaTwitter />
                    </SocialLink>
                    <SocialLink href="#" target="_blank" aria-label="LinkedIn">
                      <FaLinkedin />
                    </SocialLink>
                    <SocialLink href="#" target="_blank" aria-label="Instagram">
                      <FaInstagram />
                    </SocialLink>
                    <SocialLink href="#" target="_blank" aria-label="YouTube">
                      <FaYoutube />
                    </SocialLink>
                  </SocialLinks>
                </FooterBrand>
              </AnimateOnScroll>
            </FooterSection>

            <FooterSection>
              <AnimateOnScroll animation="fadeUp" delay={200} duration={800}>
                <div>
                  <FooterTitle className="font18 extraBold whiteColor">Quick Links</FooterTitle>
                  <FooterLinks>
                    <FooterLink>
                      <Link to="home" smooth={true} offset={-80}>Home</Link>
                    </FooterLink>
                    <FooterLink>
                      <Link to="wings" smooth={true} offset={-80}>Our Wings</Link>
                    </FooterLink>
                    <FooterLink>
                      <Link to="projects" smooth={true} offset={-80}>Success Stories</Link>
                    </FooterLink>
                    <FooterLink>
                      <Link to="blog" smooth={true} offset={-80}>Blog</Link>
                    </FooterLink>
                    <FooterLink>
                      <Link to="reviews" smooth={true} offset={-80}>Reviews</Link>
                    </FooterLink>
                    <FooterLink>
                      <Link to="contact" smooth={true} offset={-80}>Contact</Link>
                    </FooterLink>
                  </FooterLinks>
                </div>
              </AnimateOnScroll>
            </FooterSection>

            <FooterSection>
              <AnimateOnScroll animation="fadeUp" delay={400} duration={800}>
                <div>
                  <FooterTitle className="font18 extraBold whiteColor">Our Programs</FooterTitle>
                  <FooterLinks>
                    <FooterLink>
                      <a href="#wings">AFRIQ BUSINESS</a>
                    </FooterLink>
                    <FooterLink>
                      <a href="#wings">AFRIQ PREPA</a>
                    </FooterLink>
                    <FooterLink>
                      <a href="#upcomingevents">Upcoming Events</a>
                    </FooterLink>
                    <FooterLink>
                      <a href="#contact">Scholarship Program</a>
                    </FooterLink>
                    <FooterLink>
                      <a href="#contact">Admission Process</a>
                    </FooterLink>
                  </FooterLinks>
                </div>
              </AnimateOnScroll>
            </FooterSection>

            <FooterSection>
              <AnimateOnScroll animation="fadeUp" delay={600} duration={800}>
                <div>
                  <FooterTitle className="font18 extraBold whiteColor">Contact Info</FooterTitle>
                  <ContactInfo>
                    <ContactItem>
                      <ContactIcon>
                        <FaMapMarkerAlt />
                      </ContactIcon>
                      <ContactText>
                        <p className="font14">Commercial Avenue</p>
                        <p className="font14">Bamenda, Cameroon</p>
                      </ContactText>
                    </ContactItem>
                    
                    <ContactItem>
                      <ContactIcon>
                        <FaPhone />
                      </ContactIcon>
                      <ContactText>
                        <p className="font14">+237 679235785</p>
                        <p className="font14">+237 679052039</p>
                        <p className="font14">+237 676282853</p>
                        <p className="font14">+237 670 45 06 90</p>
                        <p className="font14">+237 676411380</p>
                      </ContactText>
                    </ContactItem>
                    
                    <ContactItem>
                      <ContactIcon>
                        <FaEnvelope />
                      </ContactIcon>
                      <ContactText>
                        <p className="font14">info@afriqcm.com</p>
                      </ContactText>
                    </ContactItem>
                  </ContactInfo>
                </div>
              </AnimateOnScroll>
            </FooterSection>
          </FooterMain>

          <FooterBottom>
            <AnimateOnScroll animation="fadeUp" delay={800} duration={800}>
              <FooterBottomContent>
                <Copyright className="font13">
                  © {getCurrentYear()} AFRIQ Bamenda. All rights reserved.
                </Copyright>
                <BackToTop onClick={scrollToTop}>
                  <FaArrowUp />
                  <span className="font13">Back to Top</span>
                </BackToTop>
              </FooterBottomContent>
            </AnimateOnScroll>
            <AnimateOnScroll animation="fadeUp" delay={1000} duration={800}>
              <PoweredBy className="font12">
                Powered by <span className="gradient-text">Deep X Labs</span>
              </PoweredBy>
            </AnimateOnScroll>
          </FooterBottom>
        </div>
      </FooterContent>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;

const FooterContent = styled.div`
  background: #4b2e83;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
      radial-gradient(circle at 20% 80%, rgba(75, 46, 131, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(75, 46, 131, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 40% 40%, rgba(75, 46, 131, 0.1) 0%, transparent 50%);
    z-index: 1;
  }
`;

const FooterMain = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 40px;
  padding: 60px 0 40px;
  position: relative;
  z-index: 2;
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
    gap: 35px;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 35px;
    padding: 50px 0 35px;
  }
  
  @media (max-width: 480px) {
    gap: 30px;
    padding: 40px 0 30px;
  }
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterBrand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const BrandDescription = styled.p`
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  margin: 0;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 15px;
`;

const SocialLink = styled.a`
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
  justify-content: center;
  color: white;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  }
  
  svg {
    font-size: 16px;
  }
`;

const FooterTitle = styled.h3`
  margin-bottom: 20px;
  color: white;
`;

const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const FooterLink = styled.li`
  a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-size: 14px;
    transition: all 0.3s ease;
    display: block;
    
    &:hover {
      color: #4b2e83;
      transform: translateX(5px);
    }
  }
`;

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

const ContactIcon = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  flex-shrink: 0;
`;

const ContactText = styled.div`
  flex: 1;
  
  p {
    color: rgba(255, 255, 255, 0.8);
    margin: 2px 0;
    line-height: 1.4;
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 30px 0;
  position: relative;
  z-index: 2;
`;

const FooterBottomContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
`;

const Copyright = styled.p`
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  
  .gradient-text {
    background: #4b2e83;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 600;
  }
`;

const BackToTop = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 25px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  }
  
  svg {
    font-size: 14px;
  }
`;

const PoweredBy = styled.div`
  text-align: center;
  margin-top: 20px;
  color: white;
  
  .gradient-text {
    color: #ffffff !important;
    font-weight: 600;
    -webkit-text-fill-color: #ffffff !important;
    background: none !important;
  }
`;

const LogoImage = styled.img`
  width: 50px;
  height: 50px;
  object-fit: contain;
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
`;